export default __webpack_public_path__ + "static/media/self_in_grass.5b14bb28.jpg";